import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";

export class memberAddTraveller {
	private travellerForm: any = $('#member-gov-stimulustraveler');
	$scope: any = $('#member-gov-stimulustraveler');
	$scope_gov: any = $('#members-travel--stimulus');
	private addForm: any = $('#member-profile-stimulusadd');
	$scopeoverlay: any = $('#myModalTraveller');
	private memberBase: any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	$instance: any;
	checkCnt: any = 1;
	initSelectizeInputs(): any {
		let _self = this;
		let inputSelectArr: any = $.makeArray(_self.travellerForm.find('select'));
		//_self.memberBase.initSelectizeInputs(inputSelectArr);

	}
	initTextInputs(): any {
		let _self = this;
		let toDisableInputs: any = _self.travellerForm.find('.add-traveller-Airline-code input');
		toDisableInputs.each((i: number, el: any) => {
			$(el).prop({
				'disabled': 'true'
			});
			$(el).prev().css({
				'background-color': '#eee',
				'border-top-left-radius': '10px',
				'border-top-right-radius': '10px'
			});
		});

		let lastnameInputs = _self.travellerForm.find('.edit-profile--first-name input');
		lastnameInputs.attr({
			'data-parsley-pattern': '^[a-z A-Z]+$',
			'maxlength': '25'
		});

		let firstnameInputs = _self.travellerForm.find('.edit-profile--last-name input');
		firstnameInputs.attr({
			'data-parsley-pattern': '^[a-z A-Z]+$',
			'maxlength': '40',
			'minlength': '2'
		});
		let airlinenoInputs = _self.travellerForm.find('.add-traveller-airline-number input');
		airlinenoInputs.attr({
			'data-parsley-type': 'number',
			'maxlength': '20'
		});
		let passsportno = _self.travellerForm.find('.add-passport--number input');
		passsportno.attr({
			'data-parsley-pattern': '^[a-zA-Z0-9]+$'
		});
	}

	editmytraveller(): any {
		let _self = this;
		_self.$scope.find('.edittraveller-details').click((evt: any) => {
			$("input[id^='firsttraveller_0edit-']").prop('readonly', true);
			$("#member-profile-edit1").find(".use-primary-email").hide();
			$("#member-profile-edit1").find(".primaryEmailText").hide();
			$('.firsttraveller_0edit-profile--date-of-birth').css({ 'pointer-events': 'none' });
			$('.nric--IC--number--error').addClass("hideClass");
			$('.nric--IC--number--error').removeClass("showClass");
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
			$('.nric-files-upload').val('');
			$('.nric--upload--file--name').val('');
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
			$('input[name="edit-use-primary-email"][type="checkbox"]').prop('checked',false);
			let editTraveller: any;
			let disableallothers: any;
			let showeditform: any;
			editTraveller = evt.currentTarget.parentElement.className;
			$("." + editTraveller).hide();
			showeditform = evt.currentTarget.parentNode.parentElement.previousElementSibling.children[1].id;
			$("#" + showeditform).show();
			let disableall = evt.currentTarget.parentElement.parentElement;
			disableallothers = $(disableall).nextAll();
			let disableallothersqq = evt.currentTarget.parentNode.parentElement.previousElementSibling;
			let disableallothersq = $(disableallothersqq).prevUntil(".addmytraveller");
			$(disableallothers).css({ 'opacity': '0.5', 'pointer-events': 'none' });
			$(disableallothersq).css({ 'opacity': '0.5', 'pointer-events': 'none' });
			let indexedit = evt.currentTarget.parentNode.children[6].id;
			//indexedit = $('#'+indexedit).val();
			let i;
			if (($('#members-travel--stimulus').length) > 0) {
				$('.edittraveller-details').css({ 'pointer-events': 'none' });
				$('.btn-memberadd--submit').css({ 'pointer-events': 'none' });
				$('.select--checkbox').css({ 'pointer-events': 'none' });
				$('.check-box--terms--cond--section').css({ 'pointer-events': 'none' });
			}
			else {
				let circle_travel: any = evt.currentTarget.parentElement.children[1].children[2].children[0].children[0].innerText;
				$('.members-content-container .circle-travel').html(circle_travel);
			}
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
			let formData: Array<any> = [];
			let populateurl: string = '';
			if (window.location.hostname === 'localhost' && window.location.port == '5000') {
				populateurl = '/dummy-data/addtraveller.json';
			}
			else {
				populateurl = '/bin/services/new/getTravellerDetailsGTS2.0';
			}
			$.ajax({
				type: 'GET',
				url: populateurl,
				success: function (msg: any) {

					//_self.redirectUser(msg);
					if (msg != "{}") {
						let inputFields = {
							'title': editTraveller + 'edit-profile--title',
							'firstName': editTraveller + 'edit-profile--first-name',
							'lastName': editTraveller + 'edit-profile--last-name',
							'birthDate': editTraveller + 'edit-profile--date-of-birth',
							'passportnumber': editTraveller + 'edit-profile--passport-number',
							'passportExpiryDate': editTraveller + 'edit-profile--passport-expiry-date',
							'passportissuingcountry': editTraveller + 'edit-traveller--passport-issue-country',
							'nationality': editTraveller + 'edit-traveller--nationality',
							'airline': editTraveller + 'edit-traveller--airline-name-selectized',
							'airlinecode': editTraveller + 'edit-traveller--airline-codevalue',
							'airlinenumber': editTraveller + 'edit-traveller--airline-number',
							'airlinecodehid': editTraveller + 'edit-traveller--airline-code',
							'nric': editTraveller + 'add-user--NRIC--number',
							'email': editTraveller + 'edit-profile--email',
							'reemail': editTraveller + 'edit-profile--confirm-email'
						};
						let res;
						res = msg;
						let i;
						i = indexedit.split('x')[1] - 2;

						var dobcont = res.travellersDetails[i].dob;
						var date_ofbirth = new Date(dobcont);

						let data = {

							'title': res.travellersDetails[i].title,
							'firstName': res.travellersDetails[i].givenName,
							'lastName': res.travellersDetails[i].lastName,
							'birthDate': date_ofbirth,
							'email': res.travellersDetails[i].email,
							'reemail': res.travellersDetails[i].email,
							'nric': res.travellersDetails[i].nric,
							'isused': res.travellersDetails[i].isused

						};

						$.each(inputFields, (param: any, inputId: any) => {
							// console.log(param, inputId, data[param]);

							let input: any = $('#' + inputId);

							// handle select inputs
							if (input.is('select')) {
								input[0].selectize.setValue(data[param]);
							} else if (input.is('[type="checkbox"]')) {
								// handle checkbox inputs
								if (data[param]) {
									input.prop('checked', 'checked');
								}
							} else if (input.hasClass('datepicker')) {
								input.datepicker('setDate', data[param]);
								// handle date inputs
							} else {
								// handle all other inputs
								input.val(data[param]);
							}

							// handle group interests/festival inputs
							if (!input.length) {
								let inputGrp: any = $('[name="' + inputId + '"]');
								console.log(inputGrp.length, inputGrp);

								$.each(inputGrp, (i: number, inputEl: any) => {
									if ($.inArray(inputEl.value, data[param]) >= 0) {
										$(inputEl).prop('checked', 'checked');
									}
								});
							}

							input.blur();
							// manually apply state to elements if not added by blur
							input.parent().find('label').addClass('input-filled');
							input.addClass('input-focused');
						});
					}

				},
				error: function (msg: any) {
					console.log(msg);
				}
			});

		});

	}


	cancelmytraveller(): any {
		let _self = this;
		_self.$scope.find('.cancelmytraveller-edit').click((evt: any) => {
			$('.nric--IC--number--error').addClass("hideClass");
			$('.nric--IC--number--error').removeClass("showClass");
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
			$('.nric-files-upload').val('');
			$('.nric--upload--file--name').val('');
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
			$(".mytravellererror_message").html("");
			let cancelTraveller: any;
			let cancelmytravell: any;
			let cancel_showtravell: any;
			cancelTraveller = evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
			cancelmytravell = cancelTraveller.children[1].id;
			$("#" + cancelmytravell).hide();
			cancel_showtravell = cancelTraveller.nextElementSibling.children[0].className;
			$("." + cancel_showtravell).show();
			let cancel_showtra = cancelTraveller.nextElementSibling.children[0].children[3].id;
			$("#" + cancel_showtra).show();
			let cancel_showtrar = cancelTraveller.nextElementSibling.children[0].children[4].id;
			$("#" + cancel_showtrar).hide();
			let enableallothers_below = $(cancelTraveller).nextAll();
			let enableallothers_above = $(cancelTraveller).prevAll();
			$(enableallothers_below).css({ 'opacity': '1', 'pointer-events': 'auto' });
			$(enableallothers_above).css({ 'opacity': '1', 'pointer-events': 'auto' });
			if (($('#members-travel--stimulus').length) > 0) {
				$('.check-box--terms--cond--section').css({ 'pointer-events': 'auto' });
				$('.btn-memberadd--submit').css({ 'pointer-events': 'auto' });
				$('.select--checkbox').css({ 'pointer-events': 'auto' });
				for (let i = 0; i < 9; i++) {
					if ($('.firsttraveller_' + i + ' .edittraveller-details').hasClass("data-offer")) {
						$('.firsttraveller_' + i + ' .edittraveller-details').css({ 'pointer-events': 'none' });
					}
					else {
						$('.firsttraveller_' + i + ' .edittraveller-details').css({ 'pointer-events': 'auto' });
					}
				}
			}

		});
		_self.$scope.find('#cancel-add-traveller').click((evt: any) => {
			$('.nric--IC--number--error').addClass("hideClass");
			$('.nric--IC--number--error').removeClass("showClass");
			$('.file-upload--image--error').addClass("hideClass");
			$('.file-upload--image--error').removeClass("showClass");
			$('.file-upload--size--error').addClass("hideClass");
			$('.file-upload--size--error').removeClass("showClass");
			$('.nric-files-upload').val('');
			$('.nric--upload--file--name').val('');
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
			$(".mytravellererror_message").html("");
			$('#addtraveller-detail').hide();
			$('.btn-memberadd--submit').show();
			$('#addtraveller_mobileadd').show();
			$('#addtraveller_mobileadd').show();
			$("#use-primary-email").prop("checked", false);
			$('#member-profile-stimulusadd #add-profile--email').val('');
			$('#member-profile-stimulusadd #add-profile--confirm-email').val('');
			$('#member-profile-stimulusadd #add-profile--email').attr('readonly', false);
			$('#member-profile-stimulusadd #add-profile--confirm-email').attr('readonly', false);
			let cancel_addtraveller: any;
			cancel_addtraveller = evt.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
			let addenableallothers_below = $(cancel_addtraveller).nextAll();
			$(addenableallothers_below).css({ 'opacity': '1', 'pointer-events': 'auto' });
			if (($('#members-travel--stimulus').length) > 0) {
				$('.check-box--terms--cond--section').css({ 'pointer-events': 'auto' });
				$('.btn-memberadd--submit').css({ 'pointer-events': 'auto' });
				$('.select--checkbox').css({ 'pointer-events': 'auto' });
				for (let i = 0; i < 9; i++) {
					if ($('.firsttraveller_' + i + ' .edittraveller-details').hasClass("data-offer")) {
						$('.firsttraveller_' + i + ' .edittraveller-details').css({ 'pointer-events': 'none' });
					}
					else {
						$('.firsttraveller_' + i + ' .edittraveller-details').css({ 'pointer-events': 'auto' });
					}
				}
			}
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
		});
	}
	canceldeletemytraveller(): any {
		let _self = this;
		_self.$scope.find('.btn-mytraveler--cancel').click((evt: any) => {
			$.magnificPopup.close()
			$(".mytravellererror_message").html("");
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
		});
	}
	selectTraveller(): any {
		let _self = this;

		_self.$scope.find('.check-box--section').click((evt: any) => {
			var targetId = evt.target.parentNode.firstElementChild.id;
			var indexArray1 = targetId.split('_');
			var indexArray2 = indexArray1[1].split("--");
			if (_self.$scope.find('#' + targetId).is(":checked") == true) {

				$('.firsttraveller_' + indexArray2[0]).css('border', '2px solid #46a049');
				let isTravellerSelected: any = false;
				if (($('#members-travel--stimulus').length) > 0) {
					$('#members-travel--stimulus input[type=checkbox]').each(function () {
						if (!$(this).hasClass('terms_check_gst')) {
							if ($(this).is(":checked")) {
								isTravellerSelected = true;
							}
						}

					});

					if ($('#gst--form--condition').is(":checked") == true && isTravellerSelected) {
						$('.gts-container').css({ 'opacity': '1', 'pointer-events': 'auto' });
					} else {
						$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
					}
				}
			} else {
				let isTravellerSelected: any = false;
				if (($('#members-travel--stimulus').length) > 0) {
					$('#members-travel--stimulus input[type=checkbox]').each(function () {
						if (!$(this).hasClass('terms_check_gst')) {
							if ($(this).is(":checked")) {
								isTravellerSelected = true;
							}
						}

					});
				}
				if (isTravellerSelected) {
					$('.gts-container').css({ 'opacity': '1', 'pointer-events': 'auto' });
				} else {
					$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
				}
				$('.firsttraveller_' + indexArray2[0]).css('border', '1px solid #ccc');
			}


		});
		$('.check-box--terms--cond--section').click((evt: any) => {
			if ($('#gst--form--condition').is(":checked") == true) {
				let isTravellerSelected: any = false;
				if (($('#members-travel--stimulus').length) > 0) {
					$('#members-travel--stimulus input[type=checkbox]').each(function () {
						if (!$(this).hasClass('terms_check_gst')) {
							if ($(this).is(":checked")) {
								isTravellerSelected = true;
							}
						}

					});
				}
				if (isTravellerSelected) {
					$('.gts-container').css({ 'opacity': '1', 'pointer-events': 'auto' });
				} else {
					$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
				}

			} else {
				$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });
			}
		});

	}
	addmytraveller(): any {
		let _self = this;
		_self.$scope.find('.btn-memberadd--submit').click((evt: any) => {
			$('#addtraveller-detail').show();
			$('.btn-memberadd--submit').hide();
			$('#addtraveller_mobileadd').hide();
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
			$('#member-profile-stimulusadd input:not([id*="-selectized"],[id*="action"],[id*="primaryEmail"]), selectize, textarea').val('');
			var inputSelectArr = $.makeArray($('#member-profile-stimulusadd').find('select'));
			$.each(inputSelectArr, function (i: number, el: any) {
				el.selectize.clear();
			});
			if (($('#members-travel--stimulus').length) > 0) {
				$('.edittraveller-details').css({ 'pointer-events': 'none' });
				$('.select--checkbox').css({ 'pointer-events': 'none' });
				$('.check-box--terms--cond--section').css({ 'pointer-events': 'none' });
			}
			let addmy_showtrar = evt.currentTarget.parentElement.nextElementSibling;
			let addmy_showtraveller = $(addmy_showtrar).nextAll();
			$(addmy_showtraveller).css({ 'opacity': '0.5', 'pointer-events': 'none' });
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
		});

		_self.$scope.find('#addtraveller_mobileadd').click((evt: any) => {
			$('#addtraveller-detail').show();
			$('#addtraveller_mobileadd').hide();
			$('.btn-memberadd--submit').hide();
			$(".user--claimed--msg").addClass("hideClass");
			$(".user--claimed--msg").removeClass("showClass");
			$('#member-profile-stimulusadd input:not([id*="-selectized"],[id*="action"], [id*="primaryEmail"]), selectize, textarea').val('');
			var inputSelectArr = $.makeArray($('#member-profile-stimulusadd').find('select'));
			$.each(inputSelectArr, function (i: number, el: any) {
				el.selectize.clear();
			});
			if (($('#members-travel--stimulus').length) > 0) {
				$('.edittraveller-details').css({ 'pointer-events': 'none' });
				$('.select--checkbox').css({ 'pointer-events': 'none' });
				$('.check-box--terms--cond--section').css({ 'pointer-events': 'none' });
			}
			let addmy_showtravellerq = evt.currentTarget.parentElement.children[4];
			let addmy_showtravellera = $(addmy_showtravellerq).nextAll();
			$(addmy_showtravellera).css({ 'opacity': '0.5', 'pointer-events': 'none' });
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();
		});
	}
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArr = $('#add-profile--date-of-birth');
		let inputExpiryArr = $('#add-profile--passport-expiry-date');
		let inputDateArr1 = $('#firsttraveller_0edit-profile--date-of-birth');
		let inputExpiryArr1 = $('#firsttraveller_0edit-profile--passport-expiry-date');
		let inputDateArr8 = $('#firsttraveller_8edit-profile--date-of-birth');
		let inputExpiryArr8 = $('#firsttraveller_8edit-profile--passport-expiry-date');
		let inputDateArr2 = $('#firsttraveller_2edit-profile--date-of-birth');
		let inputExpiryArr2 = $('#firsttraveller_2edit-profile--passport-expiry-date');
		let inputDateArr3 = $('#firsttraveller_3edit-profile--date-of-birth');
		let inputExpiryArr3 = $('#firsttraveller_3edit-profile--passport-expiry-date');
		let inputDateArr4 = $('#firsttraveller_4edit-profile--date-of-birth');
		let inputExpiryArr4 = $('#firsttraveller_4edit-profile--passport-expiry-date');
		let inputDateArr5 = $('#firsttraveller_5edit-profile--date-of-birth');
		let inputExpiryArr5 = $('#firsttraveller_5edit-profile--passport-expiry-date');
		let inputDateArr6 = $('#firsttraveller_6edit-profile--date-of-birth');
		let inputExpiryArr6 = $('#firsttraveller_6edit-profile--passport-expiry-date');
		let inputDateArr7 = $('#firsttraveller_7edit-profile--date-of-birth');
		let inputExpiryArr7 = $('#firsttraveller_7edit-profile--passport-expiry-date');
		let inputDateArr9 = $('#firsttraveller_1edit-profile--date-of-birth');
		let inputExpiryArr9 = $('#firsttraveller_1edit-profile--passport-expiry-date');

		//let inputElArr:any = $.makeArray(inputDateArr,inputExpiryArr);

		let minDate = new Date((new Date().getFullYear() - 100).toString());
		let maxDate = new Date((new Date().getTime() - 1000 * 60 * 60 * 24 * 365 * 2));
		let expiryminDate = 0;
		let $addProfileFlag: any = $('#addProfileFlag').val();
		_self.memberBase.initDatepickerInputs(inputDateArr, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr1, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr1, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr2, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr2, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr3, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr3, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr4, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr4, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr5, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr5, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr6, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr6, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr7, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr7, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr8, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr8, expiryminDate);
		_self.memberBase.initDatepickerInputs(inputDateArr9, minDate, maxDate);
		_self.memberBase.initDatepickerInputs(inputExpiryArr9, expiryminDate);
	}

	displymytraller(): any {
		$('.myModalTraveller').hide();
		$('#showtraveller-details').show();
		$('#showtraveller-details_1').show();
		$('#showtraveller-details_2').show();
		$('#showtraveller-details_3').show();
		$('#showtraveller-details_4').show();
		$('#showtraveller-details_5').show();
		$('#showtraveller-details_6').show();
		$('#showtraveller-details_7').show();
		$('#showtraveller-details_8').show();
		$('#addtraveller-detail').hide();
		$('#updatetraveller-detail').hide();
		$('#updatetraveller-detail_1').hide();
		$('#updatetraveller-detail_2').hide();
		$('#updatetraveller-detail_3').hide();
		$('#updatetraveller-detail_4').hide();
		$('#updatetraveller-detail_5').hide();
		$('#updatetraveller-detail_6').hide();
		$('#updatetraveller-detail_7').hide();
		$('#updatetraveller-detail_8').hide();
	}
	populatedataa(): any {
		$('.file-upload--size--error').addClass("hideClass");
		let formData: Array<any> = [];
		let populateurl: string = '';
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/addtraveller.json';
		}
		else {
			populateurl = '/bin/services/new/getTravellerDetailsGTS2.0';
		}
		let _self = this;
		let bcommon = _self.bookingformcommon;
		bcommon.preloader();

		$.ajax({
			type: 'GET',
			url: populateurl,
			success: function (msg: any) {
				if (typeof msg === 'string') {
					msg = JSON.parse(msg);
				} else {
					msg = msg;
				}

				$(".mytravellererror_message").html("");
				if (msg != "{}") {
					if (msg.travellersDetails[0].isused === "EXCEED") {
						$('#members-travel--stimulus .govt-stimulus-container').hide();
						$('#members-travel--stimulus .govt-stimulus-exceed-container').show();
					}
					else {

						$(".tag-lineno").html((msg.travellersDetails.length));

						if (msg.travellersDetails.length === 1) {
							$(".tag-lineno").html("1");
						}

						let i = 0;
						if (msg.travellersDetails.length === 9) {
							$('.btn-memberadd--submit').css({ 'opacity': '0.5', 'pointer-events': 'none' });
							$('#addtraveller_mobileadd').hide();
						}
						else {
							$('.btn-memberadd--submit').css({ 'opacity': '1.0', 'pointer-events': 'auto' });
							$('#addtraveller_mobileadd').show();
						}

						for (i = 0; i < msg.travellersDetails.length; i++) {
							let j: any = 0;
							j = i;
							$('.firsttraveller_' + j).show();
							$('.firsttraveller_' + j + '  #emailmember').val(msg.travellersDetails[i].email);
							$('.firsttraveller_' + j + '  #uniqueID').val(msg.travellersDetails[i].uniqueID);
							$('.firsttraveller_' + j + '  #firstName').val(msg.travellersDetails[i].givenName);
							$('.firsttraveller_' + j + '  #lastName').val(msg.travellersDetails[i].lastName);
							if (i == 0) {
								$('#member-profile-stimulusadd #primaryEmail').val(msg.travellersDetails[i].email);
							}

							$("#traveller-title_" + j).html(msg.travellersDetails[i].title);
							$("#traveller-name_" + j).html((msg.travellersDetails[i].givenName) + '&nbsp' + (msg.travellersDetails[i].lastName));
							$("#traveller-dob_" + j).html(msg.travellersDetails[i].dob);

							//  $('.mobile-nav .mobile-enrich-login').addClass('hide')
							//  $('.mobile .enrich-login').addClass('hide');
							$(".firsttraveller_" + j + " .circle-travel").html(j + 1);
							$(".tag-lineno").html(msg.travellersDetails.length);
							$("#traveller-nric-num_" + j).html(msg.travellersDetails[i].nric);
							// if (msg.travellersDetails[i].hasPhoto == "Y") {
							// 	$("#traveller-ic-attachment_" + j).addClass("showClass");
							// 	$("#traveller-ic-attachment_" + j).removeClass("hideClass");
							// } else {
							// 	$("#traveller-ic-attachment_" + j).removeClass("showClass");
							// 	$("#traveller-ic-attachment_" + j).addClass("hideClass");
							// }
						$('.firsttraveller_'+j).css('border','1px solid #ccc');
						$('#traveller-check_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
						$('#traveller-check_'+j).show();
						if(msg.travellersDetails[i].nric!='')
						{
							
							$("#traveller-nric--details--info_"+j).addClass("hideClass");
							$("#traveller-nric--details--info_"+j).removeClass("showClass");
							$('.firsttraveller_'+j).css('border','1px solid #ccc');
							$('#traveller-check_'+j).css({ 'opacity': '1.0','pointer-events': 'auto' });
							$('#traveller-check_'+j).show();
							// if(msg.travellersDetails[i].hasPhoto=="Y")
							// 	{
							// 	}else{
							// 		$("#traveller-nric--details--info_"+j).addClass("showClass");
							// 		$("#traveller-nric--details--info_"+j).removeClass("hideClass");
							// 		$('.firsttraveller_'+j).css('border','2px solid red');
							// 		//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
							// 		$('#traveller-check_'+j).hide();
							// 	}
							
						}else{
							$('.firsttraveller_'+j).css('border','2px solid red');
							$("#traveller-nric--details--info_"+j).addClass("showClass");
							$("#traveller-nric--details--info_"+j).removeClass("hideClass");
							//$('#traveller-check_'+j).css({ 'opacity': '0.5','pointer-events': 'none' });
							$('#traveller-check_'+j).hide();
						}

							if (msg.travellersDetails[i].isused == "NOK") {
								$("#traveller-nric-num_" + j).html(msg.travellersDetails[i].nric);
							}
							if (($('#members-travel--stimulus').length) > 0) {
								if (msg.travellersDetails[i].isused == "NOK") {
									//alert("isused11==Y");
									$("#traveller-nationality--error--info_" + j).addClass("hideClass");
									$("#traveller-nationality--error--info_" + j).removeClass("showClass");
									$("#traveller-nric--details--info_" + j).addClass("hideClass");
									$("#traveller-nric--details--info_" + j).removeClass("showClass");
									$('.firsttraveller_' + j).css({ 'opacity': '0.5', 'pointer-events': 'none' });
									$('#traveller-check_' + j).hide();
									$('.firsttraveller_' + j).css('border', '1px solid #ccc');
									$("#traveller-gts--used--info_" + j).addClass("showClass");
									$("#traveller-gts--used--info_" + j).removeClass("hideClass");
									$('.firsttraveller_' + j + ' .deletetraveller-details').css({ 'pointer-events': 'auto' });
									$('.firsttraveller_' + j + ' .edittraveller-details').addClass("data-offer");
								} else {
									// $('.firsttraveller_' + j).css({ 'opacity': '1.0', 'pointer-events': 'auto' });
									$("#traveller-gts--used--info_" + j).addClass("hideClass");
									$("#traveller-gts--used--info_" + j).removeClass("showClass");
									if (msg.travellersDetails[i].isSubmitted == "Y") {
										$('.firsttraveller_' + j).css({ 'opacity': '0.5', 'pointer-events': 'none' });
										$('#traveller-check_' + j).hide();
										$('.firsttraveller_' + j).css('border', '1px solid #ccc');
										$('.firsttraveller_' + j + ' .submitted_traveller').removeClass("hide");
										$('.firsttraveller_' + j + ' .fa-edit').addClass("hide");
										$('.firsttraveller_' + j + ' .edittraveller-details').css({ 'pointer-events': 'none' });
										$('.firsttraveller_' + j + ' .edittraveller-details').addClass("data-offer");
									} else {
										$('.firsttraveller_' + j).css({ 'opacity': '1.0', 'pointer-events': 'auto' });
										$('.firsttraveller_' + j + ' .submitted_traveller').addClass("hide");
										$('.firsttraveller_' + j + ' .fa-edit').removeClass("hide");
										$('.firsttraveller_' + j + ' .edittraveller-details').css({ 'pointer-events': 'auto' });
										$('.firsttraveller_' + j + ' .edittraveller-details').removeClass("data-offer");
									}
								}

							}
							const age = moment().diff(msg.travellersDetails[i].dob, 'years');
							if (age >= 12) {
								$("#traveller-type_" + j).html("Adult");
							}
							else {
								$("#traveller-type_" + j).html("Child");
							}
							$("#index_" + (j + 1)).val(msg.travellersDetails[i].index);
							$("#unquieID_" + (j + 1)).val(msg.travellersDetails[i].uniqueID);
							$("#firsttraveller_" + j + "--select").val(msg.travellersDetails[i].index);
						}

						for (i = (msg.travellersDetails.length); i < 9; i++) {
							$('.firsttraveller_' + i).hide();
						}

					}
				}
				bcommon.preloaderClose();
			},
			error: function (error: any) {
				$('#member-gov-stimulustraveler').hide();
				$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
				$('html, body').animate({ scrollTop: '100px' });
				bcommon.preloaderClose();
			}

		});


	}
	removetraveller(): any {

		let _self = this;
		$('.btn-mytraveler--remove').click((evt: any) => {
			let indexedit: any = $("#deleteBox").val();
			indexedit = indexedit.split('x')[1] - 1;
			let i: any = $("#index_" + indexedit).val();
			$.magnificPopup.close();
			$(window).unbind('scroll');
			evt.preventDefault();
			evt.stopPropagation();

			let data: any = {
				'action': 'delete',
				'index': i
			}
			$.ajax({
				type: 'POST',
				data: data,
				url: '/bin/services/new/myTravellerDetailsAPI',
				success: function (msg: any) {
					if (typeof msg === 'string') {
						msg = JSON.parse(msg);
					} else {
						msg = msg;
					}
					$(".mytravellererror_message").html("");
					_self.populatedataa();
				},
				error: function (error: any) {
					$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
					$('html, body').animate({ scrollTop: '100px' });
				}
			});

		});
	}

	fileupload(): any {
		let defer = $.Deferred();
		let _self = this;
		//let redeemBal = _self.travellerForm.find( '#nric-files-upload');
		//let icNum = _self.travellerForm.find( '#nric--upload--file--name');
		$("#add-user--NRIC--number").keypress(function (e: any) {
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				//$(".cardnumberformatErrMsg").show();
				return false;
			}
			else {
				//$(".cardnumberformatErrMsg").remove();
				return true;
			}
		});

		for (let i = 0; i <= 8; i++) {
			$("#firsttraveller_" + i + "add-user--NRIC--number").keypress(function (e: any) {
				if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
					return false;
				}
				else {
					return true;
				}
			});
		}
		var fileExtension = ["jpg", "jpeg", "tiff", "png", "gif", "doc", "pdf"];
		let formUploadValidFileCount: any = 0;

		$(document.body).on('change', '.nric-files-upload', function () {

			/*let dob = _self.travellerForm.find( '#add-profile--date-of-birth').val();
			let icNum = _self.travellerForm.find( '#add-user--NRIC--number').val();
			let myDate = new Date(dob);
			let d = myDate.getDate()+'';
			let m =  myDate.getMonth();
			m += 1;  // JavaScript months are 0-11
			let y = myDate.getFullYear()+'';
			let dob_val=d+m+y;
			let icNum_val = icNum.substring(0, 8);
			if(icNum_val==dob_val){
				alert("true");
			}else{
				alert("false");
				_self.travellerForm.find( '#add-user--NRIC--number').val('');
			}*/



			//_self.$scope.find('.nric-files-upload').click((evt: any) => {
			let icNameAttr: any;
			//editTraveller = evt.currentTarget.parentElement.className;
			//alert("editTraveller>>"+editTraveller);
			var fsize = $(this)[0].files.item(0).size;
			//alert("fsize>>"+fsize);
			//icNum.val($(this)[0].files.item(0).name);
			let name = $(this)[0].files.item(0).name;
			//alert("name>>"+name);
			let className = $(this)[0].className;
			//alert("className>>"+className);
			//let classNameLen=$(this)[0].parentElement.className;
			//alert("className>>"+classNameLen);
			let getattr = $(this)[0].getAttribute('name');
			//alert("getattr>>"+getattr);
			//getattr=getattr.split("---")
			//alert("classNameLen>>"+getattr.length);
			//if(getattr.length==2){
			//let	attr=getattr[0];
			//alert("attr>>"+attr);
			//icNameAttr=_self.travellerForm.find('#'+attr+'nric--upload--file--name');
			//}else{
			icNameAttr = _self.travellerForm.find('.nric--upload--file--name');
			//}
			icNameAttr.val($(this)[0].files.item(0).name);

			if ((fileExtension.indexOf($(this)[0].files.item(0).name.split('.').pop().toLowerCase()) < 0)) {
				$(this).addClass('error-validation');
				formUploadValidFileCount = 0;
				//$('.file-upload--image--error').show();
				$('.file-upload--image--error').addClass("showClass");
				$('.file-upload--image--error').removeClass("hideClass");
				icNameAttr.val('');
				$('.nric-files-upload').val('');

			} else {
				$(this).removeClass('error-validation');
				formUploadValidFileCount = 1;
				//$('.file-upload--image--error').hide();
				$('.file-upload--image--error').addClass("hideClass");
				$('.file-upload--image--error').removeClass("showClass");
			}

			if ((parseFloat((fsize / (1024 * 1024)).toFixed(2)) >= 5)) {
				$(this).addClass('error-validation');
				$('.file-upload--size--error').addClass("showClass");
				$('.file-upload--size--error').removeClass("hideClass");
				icNameAttr.val('');
				$('.nric-files-upload').val('');
			} else {
				$(this).removeClass('error-validation');
				$('.file-upload--size--error').addClass("hideClass");
				$('.file-upload--size--error').removeClass("showClass");
			}
		});
	}

	hideTravellers(): any {
		if (($('#members-travel--stimulus').length) > 0) {
			$('.addmytraveller').hide();
			$('.btn-memberadd--submit').hide();
			$('.firsttraveller_0').parent().nextAll().addClass('hide');

		}
	}
	redeemSubmit(): any {
		$('#members-travel--stimulus .btn-redeem--submit').click((evt: any) => {
			evt.preventDefault();
			evt.stopPropagation();
			let _self = this;
			let bcommon = _self.bookingformcommon;
			bcommon.preloader();
			let inputGrp: any = $("#members-travel--stimulus div[class^='firsttraveller_']");
			let jsonObjRedeem: any = [];
			let jsonstrRedeem: any;
			$.each(inputGrp, (i: number, inputEl: any) => {
				if ($(inputEl).find('.select--checkbox input[type="checkbox"]').is(':checked') === true) {
					let nric: any = $(inputEl).find("p[id^='traveller-nric-num_']").text();
					let email: any = $(inputEl).find("#emailmember").val();
					let uniqueID: any = $(inputEl).find("#uniqueID").val();
					let firstName: any = $(inputEl).find("#firstName").val();
					let lastName: any = $(inputEl).find("#lastName").val();
					let title: any = $(inputEl).find("p[id^='traveller-title_']").text();
					let item: any = {};
					item["nric"] = nric;
					item["email"] = email;
					item["uniqueID"] = uniqueID;
					item["firstName"] = firstName;
					item["lastName"] = lastName;
					item["title"] = title;
					jsonObjRedeem.push(item);
				}
			});
			jsonstrRedeem = JSON.stringify(jsonObjRedeem);
			let requestData = {};
			requestData["items"] = jsonstrRedeem;
			
			$.ajax({
				type: 'POST',
				data: requestData,
				url: '/bin/services/new/gts2Registration',
				success: function (msg: any) {
					if (typeof msg === 'string') {
						msg = JSON.parse(msg);
					} else {
						msg = msg;
					}
					if(msg.status === 'success') {
						$('#members-travel--stimulus .govt-stimulus-container').hide();
						$('#members-travel--stimulus .govt-stimulus-success-container').show();
						$('#members-travel--stimulus .govt-stimulus-success-container p.message').html(msg.message);
						document.querySelector('.govt-stimulus-success-container').scrollIntoView();
						bcommon.preloaderClose();
					}
					else if(msg.status === 'fail') {					
						$('#members-travel--stimulus .govt-stimulus-container').hide();
						$('#members-travel--stimulus .govt-stimulus-failure-container').show();
						$('#members-travel--stimulus .govt-stimulus-failure-container p.message').html(msg.message);
						document.querySelector('.govt-stimulus-failure-container').scrollIntoView();
						bcommon.preloaderClose();
					}
				},
				error: function (error: any) {
					$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
					$('html, body').animate({ scrollTop: '100px' });
					bcommon.preloaderClose();
				}
			});

		});
		$('#members-travel--stimulus .back-to-home-stimulus').click((evt: any) => {
			let _self = this;
			let bcommon = _self.bookingformcommon;
			bcommon.preloader();			
			$('#members-travel--stimulus .govt-stimulus-failure-container').hide();
			$('#members-travel--stimulus .govt-stimulus-success-container').hide();
			_self.populatedataa();
			$('.gts-container').css({ 'opacity': '0.5', 'pointer-events': 'none' });			
			$('#gst--form--condition').prop('checked',false);
			$('#member-profile-stimulusadd input[name="use-primary-email"]').prop('checked',false);
			$('#members-travel--stimulus .govt-stimulus-container').show();
			bcommon.preloaderClose();
		});
	}
	setprimaryEmailAddress(): any {
		$('#member-profile-stimulusadd input[name="use-primary-email"][type="checkbox"]').change(function () {
			if ($(this).is(":checked") == true) {
				let email: any = $('#member-profile-stimulusadd #primaryEmail').val();
				$('#member-profile-stimulusadd #add-profile--email').val(email);
				$('#member-profile-stimulusadd #add-profile--confirm-email').val(email);
				$('#member-profile-stimulusadd #add-profile--email').attr('readonly', true);
				$('#member-profile-stimulusadd #add-profile--confirm-email').attr('readonly', true);
			}
			else {
				$('#member-profile-stimulusadd #add-profile--email').val('');
				$('#member-profile-stimulusadd #add-profile--confirm-email').val('');
				$('#member-profile-stimulusadd #add-profile--email').attr('readonly', false);
				$('#member-profile-stimulusadd #add-profile--confirm-email').attr('readonly', false);
			}
		});
		$('.member-profile-edit input[name="edit-use-primary-email"][type="checkbox"]').change(function () {
			let parentID: any = '#' + $(this).attr('data-parent-id');
			if ($(this).is(":checked") == true) {
				let email: any = $('#member-profile-stimulusadd #primaryEmail').val();				
				$(parentID + 'edit-profile--email').val(email);
				$(parentID + 'edit-profile--confirm-email').val(email);
				$(parentID + 'edit-profile--email').attr('readonly', true);
				$(parentID + 'edit-profile--confirm-email').attr('readonly', true);
			}
			else {
				$(parentID + 'edit-profile--email').val('');
				$(parentID + 'edit-profile--confirm-email').val('');
				$(parentID + 'edit-profile--email').attr('readonly', false);
				$(parentID + 'edit-profile--confirm-email').attr('readonly', false);
			}
		});
	}
}
let scope: Element = document.querySelector('#member-gov-stimulustraveler');

if (scope) {
	try {
		let addtraveller = new memberAddTraveller();
		addtraveller.displymytraller();
		addtraveller.initSelectizeInputs();
		addtraveller.editmytraveller();
		addtraveller.addmytraveller();
		addtraveller.cancelmytraveller();
		addtraveller.selectTraveller();
		addtraveller.removetraveller();
		addtraveller.canceldeletemytraveller();
		addtraveller.initDatepickerInputs();
		addtraveller.populatedataa();
		addtraveller.initTextInputs();
		addtraveller.fileupload();
		addtraveller.redeemSubmit();
		addtraveller.setprimaryEmailAddress();
		//addtraveller.hideTravellers();
	} catch (e) { console.error(e); }
}